import React from 'react';
import image from "../../assets/Unterschiede.jpg"
import {DelayedFrame} from "../DelayedFrame";

export function FolieUnterschiede(props) {
  return <DelayedFrame
    key={'constrast'}
    id={'contrast'}
    finish={props.finish}
    delay={60000}
  >
    <img src={image} alt={'Unterschiede beachten.'} style={{width: "110%"}}/>

  </DelayedFrame>
}

